import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloMns,cleanAloMns } from '@/models/alo/AloMns'

export default {
  getAllMns(): AxiosPromise<AlrContainer<Array<AloMns>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Mns`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloMns>>
      }]
    })
  },
  getMns(id:number):AxiosPromise<AlrContainer<AloMns>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Mns/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMns>
      }]
    })
  },
  saveMns(mns:AloMns):AxiosPromise<AlrContainer<AloMns>> {
    cleanAloMns(mns)
    if(mns.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Mns/${mns.id}`, 
        method: 'PUT',
        data: mns,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloMns>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Mns`, 
        method: 'POST',
        data: mns,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloMns>
        }]
      })    
    }
  },
  deleteMns(id:number):AxiosPromise<AlrContainer<AloMns>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Mns/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMns>
      }]
    })
  }
}